export default {"src":"/_next/static/media/FANSI.f45bafa5.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};